import ElementVariable from './ElementVariable';
import ElementVariableComponent from './components/ElementVariableComponent';

export default {
  __init__: [ 'elementVariableComponent' ],
  elementVariable: [ 'type', ElementVariable ],
  elementVariableComponent: [ 'type', ElementVariableComponent ]
};